<app-breadcrumb *ngIf="!regional" [master]="'Administracja'" [parentName]="'Regionalni'" [name]="'Dodaj'"></app-breadcrumb>
<div class="regional-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!regionalFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Imię</mat-label>
              <input appCapitalizeFirst matInput placeholder="Imię" [formControl]="firstNameControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Nazwisko</mat-label>
              <input appCapitalizeFirst matInput placeholder="Nazwisko" [formControl]="lastNameControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div [fxFlex]="!(userPermissions | async).user.admin_root ? '100' : '50'">
            <mat-form-field fxFlex="100">
              <mat-label>Email </mat-label>
              <input  matInput placeholder="adres@mail.pl" [formControl]="emailControl" [required]="true">
              <mat-error *ngIf="regionalForm.get('email').hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="regionalForm.get('email').hasError('email')">Podaj prawidłowy adres email</mat-error>
            </mat-form-field>
          </div>

          <div [fxFlex]="!(userPermissions | async).user.admin_root ? '100' : '50'">
            <mat-form-field fxFlex="100">
              <mat-label> Numer telefonu </mat-label>
              <input  matInput prefix="+48" mask=" 000 000 000" [formControl]="phoneControl" [required]="true">
              <mat-error *ngIf="regionalForm.get('phone').hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="regionalForm.get('phone').hasError('invalidPhoneNumber')">Podaj prawidłowy numer telefonu </mat-error>
            </mat-form-field>
          </div>

        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">

              <app-dict-users fxFlex="100" label="Użytkownik" [control]="accountUserControl" [multiple]="false"></app-dict-users>

          </div>
          <div *ngIf="(userPermissions | async).user.admin_root" fxFlex="50">
            <mat-form-field  fxFlex="95">
              <mat-label>Hasło</mat-label>
              <input minlength="6" matInput  [formControl]="passwordControl" [required]="true">
            </mat-form-field>

            <div fxFlex="5">
              <button  mat-icon-button color="primary" (click)="generatePassword()"  matTooltip="Generuj Hasło"><mat-icon>tune</mat-icon></button>
            </div>
          </div>

        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <mat-slide-toggle [formControl]="deletedControl" color="accent">Aktywny</mat-slide-toggle>
          </div>
        </div>

      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!regionalFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
